import axios from 'axios';
import { API_URL } from '../../api/api';

const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const base = `${API_URL}/api/dashboard-presets`;

export async function listPresets(kind) {
  const res = await axios.get(`${base}/${kind}`, { headers: authHeaders() });
  return res.data?.presets || []; // [{ id, name, layout, hidden, prefs, created_at }]
}

export async function createPreset(kind, { name, layout, hidden, prefs }) {
  const res = await axios.post(
    `${base}/${kind}`,
    { name, layout, hidden, prefs },
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return res.data; // { ok, id }
}

export async function updatePreset(id, { name, layout, hidden, prefs }) {
  const res = await axios.put(
    `${base}/id/${id}`,
    { name, layout, hidden, prefs },
    { headers: { ...authHeaders(), 'Content-Type': 'application/json' } }
  );
  return res.data;
}

export async function deletePreset(id) {
  const res = await axios.delete(`${base}/id/${id}`, { headers: authHeaders() });
  return res.data;
}
